<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelName">
                <el-input v-model="searchForm.hotelName" placeholder="请输入酒店名称" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo">
                <el-input v-model="searchForm.orderNo" placeholder="订单号" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="住客姓名" prop="customerName">
                <el-input v-model="searchForm.customerName" placeholder="请输入住客姓名" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="联系手机" prop="customerMobile">
                <el-input v-model="searchForm.customerMobile" placeholder="请输入联系手机" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择" style="width: 120px">
                    <el-option label="驳回申请" :value="2"></el-option>
                    <el-option label="同意退款" :value="3"></el-option>
                    <el-option label="审核中" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支付方式" prop="payWay">
                <el-select v-model="searchForm.payWay" placeholder="请选择" style="width: 120px">
                    <el-option label="微信支付" :value="1"></el-option>
                    <el-option label="企业预定" :value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center" fixed="left"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" width="200"></el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="200"></el-table-column>
            <el-table-column prop="statusDesc" label="状态"  width="130">
                <template slot-scope="{ row }">
                    <el-tag type="danger" v-if="row.status == 2">{{ row.statusDesc }}</el-tag>
                    <el-tag v-else>{{ row.statusDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="payWayDesc" label="支付方式"  width="130">
                <template slot-scope="{ row }">
                    <el-tag>{{ row.payWayDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="hotelName" label="酒店名称" width="230" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hotelRemark" label="审核说明" width="230" show-overflow-tooltip></el-table-column>
            <el-table-column prop="roomTypeName" label="房型" width="120"></el-table-column>
            <el-table-column prop="customerName" label="住客姓名" width="120"></el-table-column>
            <el-table-column prop="customerMobile" label="联系手机" width="120"></el-table-column>
            <el-table-column prop="refundAmount" label="退款金额" width="130"></el-table-column>
            <el-table-column prop="roomQty" label="房间数量" width="130"></el-table-column>
            <el-table-column prop="days" label="预定天数" width="120"></el-table-column>
            <el-table-column prop="estimatedCheckIn" label="开始时间" width="170"></el-table-column>
            <el-table-column prop="estimatedCheckOut" label="结束时间"  width="170"></el-table-column>
           
            <el-table-column prop="action" label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" style="color: red;" @click="handleRefund(row)" v-if="row.status == 1">审核</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        
        <el-dialog :visible.sync="isView" title="审核" width="700px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="modelForm" :model="modelForm" label-width="100px" style="margin: 0 20px" size="small">
                <div class="legend-title">订单信息</div>
                <el-table border size="small" :data="orderDetail" style="margin-bottom: 20px;">
                    <el-table-column prop="hotelName" label="酒店名称" width="230" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="days" label="预定天数" width="100"></el-table-column>
                    <el-table-column prop="roomTypeName" label="房型" width="100"></el-table-column>
                    <el-table-column prop="roomQty" label="房间数" width="100"></el-table-column>
                    <el-table-column prop="refundAmount" label="退款金额(元)" width="100"></el-table-column>
                    <el-table-column prop="estimatedCheckIn" label="入住时间" width="120"></el-table-column>
                    <el-table-column prop="estimatedCheckOut" label="退房时间"  width="120"></el-table-column>
                </el-table>
                <el-form-item label="状态" prop="status" :rules="[{required: true, message: '请选择', trigger: 'blur'}]">
                    <el-radio-group v-model="modelForm.status" style="width: 250px">
                        <el-radio :label="3">同意退款</el-radio>
                        <el-radio :label="2">驳回申请</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="驳回理由" prop="hotelRemark" v-if="modelForm.status == 2" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                    <el-input type="textarea" rows="3" v-model="modelForm.hotelRemark" placeholder="请输入驳回理由" style="width: 250px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" type="text" @click="isView = false">关闭</el-button>
                <el-button size="small" type="primary" :loading="isRefundLoading" @click="handleCancelOrder('modelForm')">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { deepClone } from '@/utils/util';
export default {
    data() {
        return {
            searchForm: {
                orderNo: "",
                payWay: "",
                hotelName: "",
                customerName: "",
                customerMobile: "",
                status: "",
                pageSize: 10,
                pageNumber: 1,
            },
            modelForm: {
                orderNo: '',
                status: 3,
                hotelRemark: ''
            },
            orderDetail: [],
            isView: false,
            isLoading: false,
            isRefundLoading: false,
            tableData: [],
            total: 0,
            hotelId: null,
            submitLoading: false,
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        handleRefund(item) {
            this.orderDetail = [item];
            this.modelForm.orderNo = item.orderNo;
            this.isView = true;
        },
        handleCancelOrder(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isRefundLoading = true;
                    this.postRequest(`/api/refundOrder/auditRefund`, this.modelForm).then((res) => {
                        this.isRefundLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success(data.msg);
                            this.isView = false;
                            this.getTableData();
                        }
                    });
                }
            })
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                orderNo: "",
                payWay: "",
                hotelName: "",
                customerName: "",
                customerMobile: "",
                status: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/refundOrder/list", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


